// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"375":"54402e19","653":"3e0fcc27","662":"ec66aa74","690":"9a412424","704":"846b86eb","987":"9a412424"}[chunkId] + ".chunk.css";
};